module.exports = __webpack_public_path__ + "~@/assets/img/3_copy.3f943ed9.png";